import React, { useState } from 'react';
import { Button, Popover } from 'antd-mobile';
import DateRangeButton from '../components/DateRangeButton';
import Permission from '../components/Permission';

import SendOverview from './SendOverview';
import BillOverview from './BillOverview';
import SendDataTrend from './SendDataTrend';
import BillDataTrend from './BillDataTrend';
import AccountOverview from './AccountOverview';

import { getDateRange } from '../utils/timeFormat';
import { AclKeys } from '../utils/permissions';
import { getSmsType, setSmsType } from '../../localStorage';

const Item = Popover.Item;

const sendDateList = ["当日", "本周", "本月", "上月"];
const sendDefaultDateRange = getDateRange("当日");

const billDateList = ["本月", "本季", "本年"];
const billDefaultDateRange = getDateRange("本月");

function Dashboard() {

  const smsType = getSmsType();

  // 发送数据概览和成功数据概览的时间段选择贯穿趋势图时间区间
  const [sendDateRange, setSendDateRange] = useState(sendDefaultDateRange);
  const [billDateRange, setBillDateRange] = useState(billDefaultDateRange);
  const [selectProductVisible, setSelectProductVisible] = useState(false);

  return <div className="container">
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <h3>{`${smsType === 'Text' ? 'USMS' : 'MMS'} 发送数据：`}</h3>
      <Popover mask
        overlayStyle={{ color: 'currentColor' }}
        visible={selectProductVisible}
        overlay={[
          (<Item key="Text" value="Text" disabled={smsType === 'Text'}>文本短信USMS</Item>),
          (<Item key="Video" value="Video" disabled={smsType === 'Video'} style={{ whiteSpace: 'nowrap' }}>彩信MMS</Item>),
        ]}
        align={{
          overflow: { adjustY: 0, adjustX: 0 },
          offset: [-10, 0],
        }}
        onVisibleChange={visible => setSelectProductVisible(visible)}
        onSelect={value => {
          setSmsType(value.key);
        }}
      >
        <Button type="primary" size='small' disabled style={{ fontSize: 12, width: 80 }}>切换产品</Button>
      </Popover>
    </div>
    <Permission aclKey={AclKeys.Dashboard}>
      <DateRangeButton
        dateList={sendDateList}
        value={sendDateRange}
        style={{ margin: '10px 0' }}
        size="small"
        onChange={dates => setSendDateRange(dates)}
        defaultRangeBtn="当日"
      />
      <div className="mb-10"><SendOverview dateRange={sendDateRange} /></div>
      <div className="mb-10"><SendDataTrend dates={sendDateRange} /></div>
      <h3 style={{ marginTop: "20px" }}>收入/成本：</h3>
      <DateRangeButton
        dateList={billDateList}
        value={billDateRange}
        style={{ margin: '10px 0' }}
        size="small"
        onChange={dates => setBillDateRange(dates)}
        defaultRangeBtn="本月"
      />
      <div className="mb-10"><BillOverview dateRange={billDateRange} /></div>
      <div className="mb-10"><BillDataTrend dates={billDateRange} /></div>
      <h3 style={{ marginTop: "20px" }}>Top10客户发送数据：</h3>
      <div className="mb-10"><AccountOverview /></div>
    </Permission>
  </div >
}

export default Dashboard